<template>
  <div class="tree-selector">
    <canvas
        ref="canvas"
        :width="canvasWidth"
        :height="canvasHeight"
        @click="handleCanvasClick"
    ></canvas>
  </div>
</template>
<script>
export default {
  data() {
    return {
      canvasWidth: 500,
      canvasHeight: 300,
      itemData:[
        {
          x: 800,
          y: 180,
          width: 300,
          height: 180,
          color: 'deepskyblue'
        },
        {
          x: 600,
          y: 680,
          width: 320,
          height: 100,
          color: 'deeppink'
        }
      ]
    }
  },
  methods:{
    handleCanvasClick (event) {
      console.log(event)
    },
    drawRect () {
      let canvas  = this.$refs.canvas
      let context = canvas.getContext('2d');
      this.itemData.forEach(function (obj) {
        context.beginPath();
        context.fillStyle = obj.color;
        context.fillRect(obj.x, obj.y, obj.width, obj.height);
        context.closePath();
      });
    }
  }
}
</script>
<style lang="less" scoped>
.tree-selector{

}
</style>


<!--<template>-->
<!--  <div class="tree-selector">-->
<!--    <canvas -->
<!--      ref="canvas" -->
<!--      :width="canvasWidth" -->
<!--      :height="canvasHeight"-->
<!--      @click="handleCanvasClick"-->
<!--      class="tree-canvas"-->
<!--    ></canvas>-->
<!--    -->
<!--    <div class="selected-path" v-if="selectedPath">-->
<!--      {{ selectedPath }}-->
<!--    </div>-->
<!--    -->
<!--    <el-button type="success" @click="confirm" class="confirm-btn">-->
<!--      确定-->
<!--    </el-button>-->
<!--  </div>-->
<!--</template>-->

<!--<script>-->
<!--export default {-->
<!--  name: 'TreeSelector',-->
<!--  data() {-->
<!--    return {-->
<!--      canvasWidth: 800,-->
<!--      canvasHeight: 600,-->
<!--      selectedNodes: [],-->
<!--      selectedPath: '',-->
<!--      // 树形节点数据-->
<!--      treeData: [-->
<!--        // 第一层-->
<!--        { id: 1, text: '左', x: 400, y: 50, width: 40, height: 40, level: 1, parent: null },-->
<!--        -->
<!--        // 第二层-->
<!--        { id: 2, text: '寸', x: 200, y: 150, width: 40, height: 40, level: 2, parent: 1 },-->
<!--        { id: 3, text: '关', x: 600, y: 150, width: 40, height: 40, level: 2, parent: 1 },-->
<!--        -->
<!--        // 第三层-->
<!--        { id: 4, text: '浮', x: 100, y: 250, width: 40, height: 40, level: 3, parent: 2 },-->
<!--        { id: 5, text: '沉', x: 300, y: 250, width: 40, height: 40, level: 3, parent: 2 },-->
<!--        { id: 6, text: '洪', x: 500, y: 250, width: 40, height: 40, level: 3, parent: 3 },-->
<!--        { id: 7, text: '弱', x: 700, y: 250, width: 40, height: 40, level: 3, parent: 3 },-->
<!--        -->
<!--        // 第四层-->
<!--        { id: 8, text: '虚', x: 150, y: 350, width: 40, height: 40, level: 4, parent: 4 },-->
<!--        { id: 9, text: '细', x: 650, y: 350, width: 40, height: 40, level: 4, parent: 7 },-->
<!--        -->
<!--        // 第五层-->
<!--        { id: 10, text: '弦', x: 150, y: 450, width: 40, height: 40, level: 5, parent: 8 }-->
<!--      ],-->
<!--      context: null-->
<!--    }-->
<!--  },-->
<!--  mounted() {-->
<!--    this.initCanvas()-->
<!--    this.draw()-->
<!--  },-->
<!--  methods: {-->
<!--    initCanvas() {-->
<!--      const canvas = this.$refs.canvas-->
<!--      this.context = canvas.getContext('2d')-->
<!--      -->
<!--      // 设置高DPI支持-->
<!--      const dpr = window.devicePixelRatio || 1-->
<!--      const rect = canvas.getBoundingClientRect()-->
<!--      -->
<!--      canvas.width = rect.width * dpr-->
<!--      canvas.height = rect.height * dpr-->
<!--      -->
<!--      this.context.scale(dpr, dpr)-->
<!--      -->
<!--      canvas.style.width = rect.width + 'px'-->
<!--      canvas.style.height = rect.height + 'px'-->
<!--    },-->
<!--    -->
<!--    // 绘制圆形节点-->
<!--    drawNode(node) {-->
<!--      const ctx = this.context-->
<!--      const centerX = node.x + node.width / 2-->
<!--      const centerY = node.y + node.height / 2-->
<!--      const radius = node.width / 2-->
<!--      -->
<!--      ctx.beginPath()-->
<!--      ctx.arc(centerX, centerY, radius, 0, 2 * Math.PI)-->
<!--      -->
<!--      // 设置颜色-->
<!--      const isSelected = this.selectedNodes.find(n => n.id === node.id)-->
<!--      if (isSelected) {-->
<!--        ctx.fillStyle = '#409EFF' // 选中状态 - 蓝色-->
<!--      } else {-->
<!--        ctx.fillStyle = '#f0f0f0' // 未选中 - 灰色节点-->
<!--      }-->
<!--      -->
<!--      ctx.fill()-->
<!--      -->
<!--      // 绘制边框-->
<!--      ctx.strokeStyle = isSelected ? '#409EFF' : '#ddd'-->
<!--      ctx.lineWidth = 2-->
<!--      ctx.stroke()-->
<!--      -->
<!--      // 绘制文字-->
<!--      ctx.fillStyle = isSelected ? 'white' : '#333'-->
<!--      ctx.font = '16px Arial'-->
<!--      ctx.textAlign = 'center'-->
<!--      ctx.textBaseline = 'middle'-->
<!--      ctx.fillText(node.text, centerX, centerY)-->
<!--    },-->
<!--    -->
<!--    // 绘制连接线-->
<!--    drawConnections() {-->
<!--      const ctx = this.context-->
<!--      -->
<!--      this.treeData.forEach(node => {-->
<!--        if (node.parent) {-->
<!--          const parent = this.treeData.find(n => n.id === node.parent)-->
<!--          if (parent) {-->
<!--            this.drawCurvedLine(parent, node)-->
<!--          }-->
<!--        }-->
<!--      })-->
<!--    },-->
<!--    -->
<!--    // 绘制弯曲连接线-->
<!--    drawCurvedLine(from, to) {-->
<!--      const ctx = this.context-->
<!--      -->
<!--      // 起点和终点坐标-->
<!--      const fromX = from.x + from.width / 2-->
<!--      const fromY = from.y + from.height-->
<!--      const toX = to.x + to.width / 2-->
<!--      const toY = to.y-->
<!--      -->
<!--      // 控制点坐标-->
<!--      const cp1x = fromX-->
<!--      const cp1y = fromY + (toY - fromY) / 3-->
<!--      const cp2x = toX-->
<!--      const cp2y = toY - (toY - fromY) / 3-->
<!--      -->
<!--      ctx.beginPath()-->
<!--      ctx.lineWidth = 2-->
<!--      ctx.strokeStyle = '#409EFF'-->
<!--      ctx.moveTo(fromX, fromY)-->
<!--      ctx.bezierCurveTo(cp1x, cp1y, cp2x, cp2y, toX, toY)-->
<!--      ctx.stroke()-->
<!--    },-->
<!--    -->
<!--    // 绘制选中路径的连接线-->
<!--    drawSelectedPath() {-->
<!--      if (this.selectedNodes.length < 2) return-->
<!--      -->
<!--      const ctx = this.context-->
<!--      -->
<!--      for (let i = 0; i < this.selectedNodes.length - 1; i++) {-->
<!--        const from = this.selectedNodes[i]-->
<!--        const to = this.selectedNodes[i + 1]-->
<!--        -->
<!--        const fromX = from.x + from.width / 2-->
<!--        const fromY = from.y + from.height-->
<!--        const toX = to.x + to.width / 2-->
<!--        const toY = to.y-->
<!--        -->
<!--        const cp1x = fromX-->
<!--        const cp1y = fromY + (toY - fromY) / 3-->
<!--        const cp2x = toX-->
<!--        const cp2y = toY - (toY - fromY) / 3-->
<!--        -->
<!--        ctx.beginPath()-->
<!--        ctx.lineWidth = 4-->
<!--        ctx.strokeStyle = '#409EFF' // 选中路径用蓝色连线-->
<!--        ctx.moveTo(fromX, fromY)-->
<!--        ctx.bezierCurveTo(cp1x, cp1y, cp2x, cp2y, toX, toY)-->
<!--        ctx.stroke()-->
<!--      }-->
<!--    },-->
<!--    -->
<!--    // 主绘制方法-->
<!--    draw() {-->
<!--      const ctx = this.context-->
<!--      ctx.clearRect(0, 0, this.canvasWidth, this.canvasHeight)-->
<!--      -->
<!--      // 绘制连接线-->
<!--      this.drawConnections()-->
<!--      -->
<!--      // 绘制选中路径-->
<!--      this.drawSelectedPath()-->
<!--      -->
<!--      // 绘制节点-->
<!--      this.treeData.forEach(node => {-->
<!--        this.drawNode(node)-->
<!--      })-->
<!--    },-->
<!--    -->
<!--    // 处理画布点击事件-->
<!--    handleCanvasClick(event) {-->
<!--      const canvas = this.$refs.canvas-->
<!--      const rect = canvas.getBoundingClientRect()-->
<!--      const x = event.clientX - rect.left-->
<!--      const y = event.clientY - rect.top-->
<!--      -->
<!--      // 检查点击的节点-->
<!--      const clickedNode = this.getClickedNode(x, y)-->
<!--      if (clickedNode) {-->
<!--        this.selectNode(clickedNode)-->
<!--      }-->
<!--    },-->
<!--    -->
<!--    // 获取点击的节点-->
<!--    getClickedNode(x, y) {-->
<!--      return this.treeData.find(node => {-->
<!--        const centerX = node.x + node.width / 2-->
<!--        const centerY = node.y + node.height / 2-->
<!--        const radius = node.width / 2-->
<!--        const distance = Math.sqrt((x - centerX) ** 2 + (y - centerY) ** 2)-->
<!--        return distance <= radius-->
<!--      })-->
<!--    },-->
<!--    -->
<!--    // 选择节点-->
<!--    selectNode(node) {-->
<!--      // 检查是否已选中-->
<!--      const existingIndex = this.selectedNodes.findIndex(n => n.id === node.id)-->
<!--      -->
<!--      if (existingIndex !== -1) {-->
<!--        // 如果已选中，则取消选中-->
<!--        this.selectedNodes.splice(existingIndex, 1)-->
<!--      } else {-->
<!--        // 检查是否可以选择（必须是连续的路径）-->
<!--        if (this.canSelectNode(node)) {-->
<!--          this.selectedNodes.push(node)-->
<!--          // 按层级排序-->
<!--          this.selectedNodes.sort((a, b) => a.level - b.level)-->
<!--        }-->
<!--      }-->
<!--      -->
<!--      this.updateSelectedPath()-->
<!--      this.draw()-->
<!--    },-->
<!--    -->
<!--    // 检查是否可以选择节点-->
<!--    canSelectNode(node) {-->
<!--      if (this.selectedNodes.length === 0) {-->
<!--        // 第一个节点必须是根节点-->
<!--        return node.level === 1-->
<!--      }-->
<!--      -->
<!--      const lastSelected = this.selectedNodes[this.selectedNodes.length - 1]-->
<!--      -->
<!--      // 检查是否是下一层的子节点-->
<!--      return node.level === lastSelected.level + 1 && node.parent === lastSelected.id-->
<!--    },-->
<!--    -->
<!--    // 更新选中路径文本-->
<!--    updateSelectedPath() {-->
<!--      this.selectedPath = this.selectedNodes.map(node => node.text).join('')-->
<!--    },-->
<!--    -->
<!--    // 确定按钮事件-->
<!--    confirm() {-->
<!--      if (this.selectedPath) {-->
<!--        this.$emit('confirm', {-->
<!--          path: this.selectedPath,-->
<!--          nodes: this.selectedNodes-->
<!--        })-->
<!--      }-->
<!--    },-->
<!--    -->
<!--    // 重置选择-->
<!--    reset() {-->
<!--      this.selectedNodes = []-->
<!--      this.selectedPath = ''-->
<!--      this.draw()-->
<!--    }-->
<!--  }-->
<!--}-->
<!--</script>-->

<!--<style scoped>-->
<!--.tree-selector {-->
<!--  padding: 20px;-->
<!--  background: white;-->
<!--  border-radius: 8px;-->
<!--  box-shadow: 0 2px 12px rgba(0,0,0,0.1);-->
<!--  text-align: center;-->
<!--}-->

<!--.tree-canvas {-->
<!--  display: block;-->
<!--  width: 800px;-->
<!--  height: 600px;-->
<!--  background: conic-gradient(#eee 25%, white 0deg 50%, #eee 0deg 75%, white 0deg) 0 / 20px 20px;-->
<!--  margin: 0 auto;-->
<!--  cursor: pointer;-->
<!--  border-radius: 8px;-->
<!--}-->

<!--@media (max-width: 640px) {-->
<!--  .tree-canvas {-->
<!--    width: 100vw;-->
<!--    height: 75vw;-->
<!--  }-->
<!--}-->

<!--.selected-path {-->
<!--  margin: 20px 0;-->
<!--  padding: 15px;-->
<!--  background: #f5f7fa;-->
<!--  border-radius: 6px;-->
<!--  font-size: 18px;-->
<!--  font-weight: bold;-->
<!--  color: #333;-->
<!--  min-height: 20px;-->
<!--}-->

<!--.confirm-btn {-->
<!--  margin-top: 15px;-->
<!--  padding: 12px 30px;-->
<!--  font-size: 16px;-->
<!--}-->
<!--</style>-->
